import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { TALLY_INTEGRATIONS } from '@constants/routes';

const TallyIntegrations = lazy(() => import('./pages/TallyIntegrations'));

export const MemberRoutes: RouteObject[] = [
  {
    path: TALLY_INTEGRATIONS.TALLY_INTEGRATIONS,
    element: <TallyIntegrations />
  }
];

export default MemberRoutes;
